import React, { Fragment, useEffect, useState } from "react";
import { Badge } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Dispatch } from "redux";
import { getApplicationVersion } from "../../store/actions/application.actions";
import { IApplicationState } from "../../store/models/IApplicationState";
import { IState } from "../../store/models/IState";
import { defaultApplicationVersion } from "../../store/reducers/application.reducer";

/**
 * Component used to load the settings from the API when the app starts.
 **/
const ApplicationVersion: React.FC = () => {
    const dispatch: Dispatch<any> = useDispatch();
    const applicationState: IApplicationState = useSelector((state: IState) => state.applicationState);
    const [version, setVersion] = useState("");
    const localStorageVersionKey: string = "TimesheetAppVersion";
    const serverVersion = applicationState?.applicationVersion?.version || "";

    useEffect(() => {
        dispatch(getApplicationVersion());
    }, [dispatch]);

    useEffect(() => {
        // Set the version to be displayed in a badge in the app.
        setVersion(serverVersion);

        const localStorageVersion = localStorage.getItem(localStorageVersionKey);

        if (localStorageVersion !== serverVersion && serverVersion !== defaultApplicationVersion) {
            // Update local storage with the latest version.
            localStorage.setItem(localStorageVersionKey, serverVersion);

            console.log(`App needs to refresh. LocalStorageVersion: ${localStorageVersion}. ServerVersion: ${serverVersion}`);

            // If the application version has been updated then force a browser cache reload.
            window.location.reload(true);
        }

    }, [serverVersion]);

    function getContent(): JSX.Element | null {
        if (!version) {
            return null;
        }

        return (
            <Badge variant="secondary" className="app-version">{version}</Badge>
        );
    }

    return (
        <Fragment>
            {getContent()}
        </Fragment>
    );
}

export default ApplicationVersion;